import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenKeysEnum } from 'src/app/global/enums/token-keys.enum';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { AuthService } from 'src/app/global/services/auth.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { StorageService } from 'src/app/global/services/storage.service';
import { TokenSaverService } from 'src/app/view-model/services/token-saver.service';
import { DialogService } from '../../../services/dialog.service';

@Injectable()
export class TokenSaverProvider extends TokenSaverService {

  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private dialog: DialogService,
    private _localStorage: LocalStorageService) {
    super();
  }

  auth(rut: number, ci: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo: number): Observable<GeneralResponse<any>> {
    return this.authService.auth(rut, ci, tokenCaptcha, dispositivoMobile, idEjecutivo).pipe(
      map(this.storeToken)
    );
  }

  authLogin(rut: number, correo: string, telefono: number, producto: string, tokenCaptcha: string, dispositivoMobile: boolean, idEjecutivo: number, isMarketplaceSVA: boolean): Observable<GeneralResponse<any>> {
    idEjecutivo = idEjecutivo != null ? Number(idEjecutivo) : null;
    return this.authService.authLogin(rut, correo, telefono, producto, tokenCaptcha, dispositivoMobile, idEjecutivo, isMarketplaceSVA).pipe(
      map(this.storeToken)
    );
  }

  private storeToken(response: GeneralResponse<any>): GeneralResponse<any> {
    localStorage.setItem(TokenKeysEnum.TOKEN, response.data);
    //    this.storageService.setItem(TokenKeysEnum.TOKEN, response.data);
    return response;
  }

  getToken(): string {
    const token = localStorage.getItem(TokenKeysEnum.TOKEN);
    // const token = this.storageService.getItem(TokenKeysEnum.TOKEN);
    return token;
  }

  saveToken(token: string): void {
    this.storageService.setItem(TokenKeysEnum.TOKEN, token);
  }

  sessionEnd() {
    const data = {
      title: 'Sesión expirada',
      description: 'El tiempo de sesión ha expirado.',
      actionButton: 'Cerrar',
      icon: '../../../assets/icons/icon-informacion.svg'
    };
    const dialogRef = this.dialog.openOneActionDialog({ data });
    dialogRef.afterClosed().subscribe(r => {
      this._localStorage.resertApp();
      window.location.reload();
    });
  }
}
